import { Component, OnInit, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Pipe } from '@angular/core';
import { IOption } from 'ng-select';
declare  const $;
import { ToastyService, ToastyConfig, ToastOptions, ToastData } from 'ng2-toasty';
import * as moment from 'moment/moment';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AlertComponent } from './../alert/alert.component';
import { Popup } from 'ng2-opd-popup';


@Component({
  selector: 'app-model',
  templateUrl: './model.component.html',
  styleUrls: ['./model.component.scss']
})

export class ModelComponent implements OnInit {
	labourcostDetailsArray=[];
	ToolTip="Delete is not allowed since it is used in contract registration page";
	makeedit:string="SELECT A MAKE";
	selectedValues:any;
	loading:boolean=true;
	ListMakeDetails:any[] = [];
	ListOfModelDetails:any[] = [];
	msgtext:any;
	btnName='Submit';
	isValid:boolean=true;
	newMake_err:boolean=false;
	newModel_err:boolean=false;
	labourcost_err:boolean=false;
	myFormsOptions: Array<IOption> = []
	make:any="";
	model:any;
	labourCost:any;
	EditObjectId:any;
	startingCount:number = 0;
	endingCount:number = 0;
	p: number = 1;
	@ViewChild('add') add: Popup;
 	@ViewChild('update') update: Popup;
	@ViewChild('Askdelete') Askdelete: Popup;
	@ViewChild('delete') delete: Popup;
	@ViewChild('duplicate') duplicate: Popup;
	deleteId:any;
	ListserviceTypeDetails:any[] = [];
	servicetype:any;
	servicetype_err:boolean=false;
	ListModelDetails:any[] = [];
	orgId:number;
	userId:number;
	makeName;
	duplicateMessage:string = 'This Model Already Exists';
	isMakeDetailsLoaded:boolean = false;
	isDeleteAvailabilityLoaded:boolean = false;
	constructor(private dialogService:DialogService,private router:Router,private route : ActivatedRoute,private http: Http,private toastyService:ToastyService,private toastyConfig: ToastyConfig) { }

	ngOnInit() {
	
		this.loading=true;
		this.isMakeDetailsLoaded = false;
		this.isDeleteAvailabilityLoaded = false;
		if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
	      window.location.href = 'https://still.alshirawi.com/highmessaging/';
	    } else {
	      this.orgId=this.route.params['value'].orgId;
	      this.userId=this.route.params['value'].userId;
	      console.log('OrgId '+ this.orgId);
	      console.log('UserId '+ this.userId);
			}
		
			
		
		//this.checkTooltip();
		this.getAllDetailsFromCheckListMaster();
		this.getAllMakedetails ();
	
	}
	getlabourcostdetails(){
	
		let makeobj={
			'orgId':this.orgId
		}
		return this.http.post('/api/getLabourCostdetails',makeobj).subscribe(
			res=>{
				this.loading=false;
				let response=res.json();
				console.log(response);
				if(response.length>0){
					this.labourcostDetailsArray=response;
					// this.checkTooltip();
				} else {
					this.loading=false;
				}
			
			},(err)=>{
				this.loading=false;
			}
		)
	}

	showAlertForAddingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"ADD MODEL",message:"The Data added successfully"});
	}
	
	showAlertForUpdatingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"UPDATE MODEL",message:"The Data updated successfully"});
	}

	showAlertForDeletingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"DELETE MODEL",message:"The Data deleted successfully"});
	}

	showDuplicatePopup(message) {
		this.duplicateMessage = message;
		this.duplicate.options = {
	        showButtons: false,
	        color: "#4180ab",
	        header: "Model"
	    };
	    this.duplicate.show(this.duplicate.options);
	}
	


	addOk() {
		this.add.hide();
	}

	updateOk() {
		this.update.hide();
	}

	deleteOk() {
		this.delete.hide();
	}

	duplicateOk() {
		this.duplicate.hide();
	}

	updateLoadingState() {
		this.loading = !(this.isMakeDetailsLoaded && this.isDeleteAvailabilityLoaded);
	}

	getFormId(value){
		console.log(value);
	}
	getAllMakedetails () {
		
		let makeObj = {
			'orgId':this.orgId
		}
	    return this.http.post('/api/getMakedetails', makeObj).subscribe(
	    res => {
			console.log('make repsoe ', res.json());
	        let ResponeMake = res.json();
			this.ListMakeDetails = res.json();
			let makeValue=[];
			for(let i=0 ;i<this.ListMakeDetails.length;i++){
				makeValue.push({'value':this.ListMakeDetails[i]._id.toString(),'label':this.ListMakeDetails[i].make.toUpperCase()})
			}    
			this.myFormsOptions=makeValue;
			this.isMakeDetailsLoaded = true;
			this.updateLoadingState();
		
		},(err) =>{
			this.isMakeDetailsLoaded = true;
			this.updateLoadingState();
	      	if(err.status != 200){
		        this.msgtext = "Unable to load the Value";
		        this.getWarningFunction(this.msgtext);
		    }
	    })
  	}

  	

  	getCount(){
	   if(this.p < Math.ceil(this.ListMakeDetails.length/10)){
	     this.startingCount = (this.p-1)*10;
	     if(this.startingCount == 0){
	       this.startingCount = 1;
	     }
	     this.endingCount = this.p*10;
	   } else if(this.p == Math.ceil(this.ListMakeDetails.length/10)){
	     let count = this.ListMakeDetails.length%10;
	     this.startingCount = (this.p-1)*10;
	     this.endingCount = this.startingCount + count;
	     if(this.startingCount == 0){
	       this.startingCount = 1;
	       this.endingCount = count;
	     }
	   }
	  }

  	_keyPress(event: any) {
	    const pattern = /[0-9\.\ ]/;
	    let inputChar = String.fromCharCode(event.charCode);

	    if (!pattern.test(inputChar)) {
	      // invalid character, prevent input
	      event.preventDefault();
	    }
	}

  	getAllDetailsFromCheckListMaster () {
  		let modelObj = {
			'orgId':this.orgId
		}
	    return this.http.post('/api/getMakeANDModelDetails', modelObj).subscribe(
	    res => {
	    	let Response = res.json();
			this.ListOfModelDetails=[];
	    	if(Response.length>0) {
	    		this.ListOfModelDetails = res.json();
				this.getCount();
				this.loadDeleteAvailability();
			
	    	} else {
					this.isDeleteAvailabilityLoaded = true;
					this.updateLoadingState();
	    	}
	      
	    },(err) =>{
		
			this.isDeleteAvailabilityLoaded = true;
			this.updateLoadingState();
			this.getCount();
			if(err.status != 200){
				this.msgtext = "Unable to load the Value";
				this.getWarningFunction(this.msgtext);
			}
	    })
	}

	loadDeleteAvailability() {
		let modelIds = [];

		for(let i=0;i<this.ListOfModelDetails.length;i++) {
			this.ListOfModelDetails[i].status = false;
			this.ListOfModelDetails[i].deleteBlockedReason = '';
			modelIds.push(this.ListOfModelDetails[i]._id);
		}

		return this.http.post('/api/getModelDeleteAvailability', {
			'ids':modelIds,
			'orgId':this.orgId
		}).subscribe(
			res => {
				let availabilityResponse = res.json().availability || {};

				for(let i=0;i<this.ListOfModelDetails.length;i++) {
					if(availabilityResponse[String(this.ListOfModelDetails[i]._id)] && availabilityResponse[String(this.ListOfModelDetails[i]._id)].canDelete === false) {
						this.ListOfModelDetails[i].status = true;
						this.ListOfModelDetails[i].deleteBlockedReason = availabilityResponse[String(this.ListOfModelDetails[i]._id)].reason || this.ToolTip;
					}
				}

				this.isDeleteAvailabilityLoaded = true;
				this.updateLoadingState();
			},(err) => {
				this.isDeleteAvailabilityLoaded = true;
				this.updateLoadingState();
				if(err.status != 200){
					this.msgtext = "Unable to validate delete availability";
					this.getWarningFunction(this.msgtext);
				}
			}
		)
	}

	getMakedetails() {
		
		if(this.make == "" || this.make == undefined || this.make == null) {
			this.newMake_err=true;
			this.isValid=false;
		} else {
			this.getmodalValueBasedOnMakeId();
			this.newMake_err=false;
			this.isValid=true;
		}
		this.ListMakeDetails.filter((val)=>{
			if(val._id == parseInt(this.make)){
				this.makeName = val.make;
			}
		})
	}


	Inputlabour() {
		if(this.labourCost == "" || this.labourCost == undefined || this.labourCost == null) {
			this.labourcost_err=true;
			this.isValid=false;
		} else {
			this.labourcost_err=false;
			this.isValid=true;
		}
	}

	Inputmodel() {
		if(this.make == "" || this.make == undefined || this.make == null) {
			alert('please select Make');
			this.model="";
		}
		if(this.model == "" || this.model == null || this.model == undefined) {
			this.newModel_err = true;
			this.isValid=false;
		} else {
			this.newModel_err = false;
			this.isValid=true;
		}
	}

	getserviceTypedetails() {
		
		if(this.servicetype == "" || this.servicetype == null || this.servicetype == undefined) {
			this.servicetype_err = true;
			this.isValid=false;
		} else {
			this.servicetype_err = false;
			this.isValid=true;
		}
	}

	getmodalValueBasedOnMakeId() {
	    let reqModelObj = {
	        'MakeId':this.make,
	        'orgId':this.orgId
	      }
	      return this.http.post('/api/getModeldetails', reqModelObj).subscribe(
	      res => {
				 // this.spinner.hide();
				 this.loading=false;
	        let ResponeModel = res.json();
	        this.ListModelDetails = res.json();
	      },(err) =>{
	        if(err.status != 200){
	          this.msgtext = "Unable to load the Value";
	          this.getWarningFunction(this.msgtext);
	        }
	      })
	  }

	Empty() {
		this.make="";
		this.model="";
		this.labourCost="";
		this.newMake_err = false;
		this.newModel_err = false;
		this.labourcost_err = false;
		this.isValid=true;
		this.btnName='Submit';
		this.EditObjectId = "";
		this.servicetype = "" ;
		this.servicetype_err = false;
		this.makeedit="SELECT A MAKE";
	}

	reset() {
		this.Empty();
	}



	addModel() {
	
			//this.spinner.show();
			this.loading=true;
	   
	    if(this.make == "" || this.make == undefined || /^\s*$/.test(this.make)) {
	        this.newMake_err = true;
				 this.loading=false;
	    } else if(this.model == "" || this.model == undefined || this.model == null|| /^\s*$/.test(this.model)) {
		    this.newModel_err = true;
				this.loading=false;
	    } else {
	    	if(this.EditObjectId === "" || this.EditObjectId === undefined || this.EditObjectId === null) {
	    		let reqModelObj = {
		          'make':this.make,
		          'model':this.model.toLowerCase(),
		          'orgId':this.orgId,
			      'created_By':this.userId,
			      'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
				}
		        return this.http.post('/api/addmodelValue', reqModelObj).subscribe(
		        res => {
		          
		          let modelResponse = res.json();
		          if(modelResponse.message == 'This Model Already Exists') {
								this.loading=false;
		            this.showDuplicatePopup('This Model Already Exists');
		          } else {
		            this.MYSQLEntryModelAdd();
		          }
		        },(err) =>{
							this.loading=false;
		          if(err.status != 200){
		            this.msgtext = "Unable to load the Value";
		            this.getWarningFunction(this.msgtext);
		          }
		        })
	    	} else {
	    		let reqModelObj = {
		          'make':this.make,
		          'model':this.model.toLowerCase(),
		          'objectId':this.EditObjectId,
		          'orgId':this.orgId,
			      'updated_By':this.userId,
			      'updated_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
		        }
		        return this.http.post('/api/UpdateModeldetails', reqModelObj).subscribe(
		        res => {
		        
		          let modelResponse = res.json();
		          if(modelResponse.message == 'This Model Already Exist') {
								//this.spinner.hide();
								this.loading=false;
		            this.showDuplicatePopup('This Model Already Exists');
		          } else {
		            this.MYSQLEntryModelUpdate();
		          }
		        },(err) =>{
							//this.spinner.hide();
							this.loading=false;
		          if(err.status != 200){
		            this.msgtext = "Unable to load the Value";
		            this.getWarningFunction(this.msgtext);
		          }
		        })
	    	}
	        
	    }
	}

    MYSQLEntryModelAdd() {
	    let reqModelObj = {
	        'make':this.make,
			'model':this.model.toLowerCase(),
			'makeName':this.makeName,
	      	'orgId':this.orgId,
	      	'created_By':this.userId,
	      	'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
	    }
	    return this.http.post('/api/MYSQLaddmodelValue', reqModelObj).subscribe(
	    res => {
					//this.spinner.hide();
					this.loading=false;
	        this.showAlertForAddingdata()
	        this.Empty();
	        this.getAllDetailsFromCheckListMaster ();
	    },(err)=>{
				//this.spinner.hide();
				this.loading=false;
	      this.msgtext = "Unable to add the model Value";
	      this.getWarningFunction(this.msgtext);
	    })
	}

	MYSQLEntryModelUpdate() {
	    let reqModelObj = {
	        'make':this.make,
	      	'model':this.model.toLowerCase(),
	      	'objectId':this.EditObjectId,
	      	'updated_By':this.userId,
			'updated_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
	    }
	    return this.http.post('/api/MYSQLUpdateModelDetails', reqModelObj).subscribe(
	    res => {
				 // this.spinner.hide();
				 this.loading=false;
	        this.showAlertForUpdatingdata();
	        this.Empty();
	        this.getAllDetailsFromCheckListMaster ();
	    },(err)=>{
				//this.spinner.hide();
				this.loading=false;
	      this.msgtext = "Unable to add the model Value";
	      this.getWarningFunction(this.msgtext);
	    })
	}



	Editing(index, ObjectId) {

	    document.body.scrollTop = 0;
	    document.documentElement.scrollTop = 0;
		this.EditObjectId=ObjectId;
		this.btnName='Update';
	    // this.make = this.ListOfModelDetails[index].makeId.toString();
	    for(let i=0;i<this.ListOfModelDetails.length;i++){
		  if(this.ListOfModelDetails[i]._id==ObjectId){
		   this.make = this.ListOfModelDetails[i].makeId.toString();
		   this.makeedit=this.ListOfModelDetails[i].make;
		   this.model = this.ListOfModelDetails[i].model.toUpperCase();
		  }
	 	}
	}

	Delete(index, deleteId, modelRow?) {
		document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
		if(modelRow && modelRow.status === true) {
			this.msgtext = modelRow.deleteBlockedReason || this.ToolTip;
			this.getWarningFunction(this.msgtext);
			return false;
		}
		this.Empty();
		this.deleteId = deleteId;
		this.Askdelete.options = {
	        showButtons: false, // You can hide this in case you want to use custom 
	        color: "#4180ab",
	        header: "Delete Model"
	    };
	    this.Askdelete.show(this.Askdelete.options);
	}

	No() {
		this.Askdelete.hide();
	}

	Yes() {
		this.Askdelete.hide();
		//this.spinner.show();
		this.loading=true;
		let reqModelObj = {
	        'deleteId':this.deleteId,
	        'orgId':this.orgId
	    }
	    return this.http.post('/api/deleteModelDetails', reqModelObj).subscribe(
	      res => {
	        let modelResponse = res.json();
					if(modelResponse && modelResponse.canDelete === false) {
						this.loading=false;
						this.msgtext = modelResponse.reason || this.ToolTip;
						this.getWarningFunction(this.msgtext);
						this.getAllDetailsFromCheckListMaster();
						return false;
					}
	        this.MYSQLDeletemake();
	    },(err)=>{
				 // this.spinner.hide();
				 this.loading=false;
	        this.msgtext = "Unable to Add the Value in mysql";
	        this.getWarningFunction(this.msgtext);
	    })
	}


	checkTooltip(){

		if(this.ListMakeDetails.length == 0 || this.ListMakeDetails.length == undefined||this.ListMakeDetails==undefined) {
			this.getAllMakedetails();
		}else if(this.ListOfModelDetails.length==0||this.ListOfModelDetails.length==undefined||this.ListOfModelDetails==undefined){
			this.getAllDetailsFromCheckListMaster()
		}else if(this.labourcostDetailsArray.length==0||this.labourcostDetailsArray.length==undefined||this.labourcostDetailsArray==undefined){
			this.getlabourcostdetails()
		}else{
		for(let z=0;z<this.ListOfModelDetails.length;z++){
			for(let i=0;i<this.labourcostDetailsArray.length;i++){
				if(this.ListOfModelDetails[z]._id==this.labourcostDetailsArray[i].modelId){
					this.ListOfModelDetails[z].status = true;
				}
			}
		}
		this.loading=false;
	 }
	

	
	}


	

	MYSQLDeletemake() {
		let reqModelObj = {
	        'deleteId':this.deleteId
	    }
		return this.http.post('/api/MYSQLDeleteModelDetails', reqModelObj).subscribe(
	      res => {
				 // this.spinner.hide();
				 
	        let modelResponse = res.json();
	      //   this.delete.options = {
		    //     showButtons: false, // You can hide this in case you want to use custom 
		    //     color: "#4180ab",
		    //     header: "Model Deleted"
		    // };
				// this.delete.show(this.delete.options);
				this.showAlertForDeletingdata();
		    this.deleteId="";
	        this.getAllDetailsFromCheckListMaster ();
					this.Empty();
					this.loading=false;
	    },(err)=>{
					//this.spinner.hide();
					this.loading=false;
	        this.msgtext = "Unable to Add the Value in mysql";
	        this.getWarningFunction(this.msgtext);
	    })
	}

	deletesuccessOk() {
		this.delete.hide();
	}

  	getWarningFunction(errMsg) {
	    var toastOptions:ToastOptions = {
	        title: "Make",
	        msg: errMsg,
	        showClose: true,
	        timeout: 3000,
	        theme: 'bootstrap',
	        onAdd: (toast:ToastData) => {
	        },
	        onRemove: function(toast:ToastData) {
	        }
	    };
        this.toastyService.warning(toastOptions);
    }//getWarningFunction end here


	getSuccessFunction(successMsg){
	    var toastOptions:ToastOptions = {
	      title: "Make",
	      msg: successMsg,
	      showClose: true,
	      timeout: 3000,
	      theme: 'bootstrap',
	      onAdd: (toast:ToastData) => {
	      },
	      onRemove: function(toast:ToastData) {
	      }
	    };
	    this.toastyService.success(toastOptions);
	}//getSuccessFunction end here
}


// WEBPACK FOOTER //
// ./client/app/model/model.component.ts